export default "__VITE_ASSET__Bj0VCcW4__"